// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
// import axios from 'axios'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
// import 'firebase/analytics'

import Vuex from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(Vuetify)
Vue.use(Vuex)
Vue.config.productionTip = false
// Vue.prototype.$http = axios
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA4IUz9Oje9bZgHzgZS24_XSgD7SzCvT0g',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',
  }

  // // If you intend to programmatically custom event listener code
  // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // // you might need to turn this on.
  // autobindAllEvents: false,

  // // If you want to manually install components, e.g.
  // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // // Vue.component('GmapMarker', GmapMarker)
  // // then disable the following:
  // installComponents: true,
})

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyDjSpgZDSkiZXnaEMQMgKEf9TIjjVThaME',
  // authDomain: 'wcms-checker.firebaseapp.com',
  authDomain: 'manager.powercheck.kr',
  databaseURL: 'https://wcms-checker.firebaseio.com',
  projectId: 'wcms-checker',
  storageBucket: 'wcms-checker.appspot.com',
  messagingSenderId: '758119380341',
  appId: '1:758119380341:web:e6a89609e648fa79'
}
firebase.initializeApp(config)
// firebase.analytics()

const store = new Vuex.Store({
  state: {
    session: {
      group: 'daejeon',
      admin: false
    }
  },
  mutations: {
    setGroup (state, payload) {
      state.session.group = payload
    },
    setAdmin (state, payload) {
      if (payload) {
        state.session.guest = false // admin 이면 guest 아님
      }

      state.session.admin = payload
    },
    setGuest (state, payload) { // 둘러보기 계정인가?
      if (payload) {
        state.session.admin = false // guest 면 admin 이 아님
      }

      state.session.guest = payload
    }
  }
})

function isDebug () {
  if (process.env.NODE_ENV !== 'production') {
    return true
  } else if (window.location.host.includes('localhost')) {
    return true
  /* } else if (window.android) {
    try {
      const appInfo = JSON.parse(window.android.getAppInfo())
      return appInfo.debug
    } catch (e) {
      return false
    }
  */
  } else {
    return false
  }
}

Vue.prototype.$DEBUG = isDebug()
Vue.prototype.$fs = {
  collection (collection) {
    // return firebase.firestore().collection(collection + '_' + store.state.session.group)
    return firebase.firestore().collection(collection)
  },
  db () {
    return firebase.firestore()
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

/*
const API_KEY = 'f07d0ab233f1f023b8a2e1170cbdca49'

Vue.prototype.$api = {
  get: function (path) {
    return axios.get('http://localhost:3000/v0_1' + path,
      {'headers': {'x-api-key': API_KEY}})
  },
  delete: function (path) {
    return axios.delete('http://localhost:3000/v0_1' + path,
      {'headers': {'x-api-key': API_KEY}})
  },
  post: function (path, data) {
    return axios.post('http://localhost:3000/v0_1' + path,
      data,
      {'headers': {'x-api-key': API_KEY}})
  },
  put: function (path, data) {
    return axios.put('http://localhost:3000/v0_1' + path,
      data,
      {'headers': {'x-api-key': API_KEY}})
  },
  patch: function (path, data) {
    return axios.patch('http://localhost:3000/v0_1' + path,
      data,
      {'headers': {'x-api-key': API_KEY}})
  }
}
*/



// WEBPACK FOOTER //
// ./src/main.js